import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { IntlProvider, useIntl } from 'react-intl';
import { connect } from 'react-redux';

import { setConfirmIntl } from '../Error/ErrorActions';

// Keeps the module-level intl used by confirmAction in sync with the active locale.
function ConfirmIntlBridge() {
    const intl = useIntl();
    useEffect(() => {
        setConfirmIntl(intl);
    }, [intl]);
    return null;
}

function IntlWrapper({ intl, children }) {
    return (
        <IntlProvider {...intl}>
            <ConfirmIntlBridge />
            {children}
        </IntlProvider>
    );
}

IntlWrapper.propTypes = {
  children: PropTypes.element.isRequired,
  intl: PropTypes.object.isRequired,
};

// Retrieve data from store as props
function mapStateToProps(store) {
  return {
    intl: store.intl,
  };
}

export default connect(mapStateToProps)(IntlWrapper);
